var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/mouse-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mouse-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M58.05 7.5H28.2375C15.2625 7.5 7.53748 15.225 7.53748 28.2V58.0125C7.53748 70.9875 15.3 78.7125 28.2375 78.7125H58.05C71.025 78.7125 78.75 70.9875 78.75 58.0125V28.2C78.75 15.225 70.9875 7.5 58.05 7.5Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.35 70.65L76.2375 72.7125C74.55 73.275 73.2 74.5875 72.6375 76.3125L70.575 82.425C68.8125 87.7125 61.3875 87.6 59.7375 82.3125L52.8 60C51.45 55.575 55.5375 51.45 59.925 52.8375L82.275 59.775C87.525 61.425 87.6 68.8875 82.35 70.65Z",
    fill: "#1DD899"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedNode);
export default __webpack_public_path__ + "static/media/selectedNode.c2d494191047f43bda46d8031788e51e.svg";
export { ForwardRef as ReactComponent };